<!-- resources/js/components/ExampleComponent.vue -->

<template>
    <div>
        <h2>Componente Vue.js</h2>
        <p>{{ message }}</p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            message: 'Olá do Vue.js! Div apenas para mostrar que a integração com o vue está dando certo.',
        };
    },
};
</script>

<style scoped>
/* Estilos específicos do componente, se necessário */
</style>
